"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RevisionState = exports.MemberRole = exports.NodeType = void 0;
var NodeType;
(function (NodeType) {
    NodeType["File"] = "file";
    NodeType["Folder"] = "folder";
    /**
     * Album is a special type available only in Photos section.
     *
     * The SDK does not support any album-specific actions, but it can load
     * the node and do general operations on it, such as sharing. However,
     * you should not rely that anything can work. It is not guaranteed that
     * and in the future specific Photos SDK will support albums.
     *
     * @deprecated This type is not part of the public API.
     */
    NodeType["Album"] = "album";
})(NodeType || (exports.NodeType = NodeType = {}));
var MemberRole;
(function (MemberRole) {
    MemberRole["Viewer"] = "viewer";
    MemberRole["Editor"] = "editor";
    MemberRole["Admin"] = "admin";
    MemberRole["Inherited"] = "inherited";
})(MemberRole || (exports.MemberRole = MemberRole = {}));
var RevisionState;
(function (RevisionState) {
    RevisionState["Active"] = "active";
    RevisionState["Superseded"] = "superseded";
})(RevisionState || (exports.RevisionState = RevisionState = {}));
//# sourceMappingURL=nodes.js.map